import Box from '@material-ui/core/Box'

export default function PaddedLayout({ children }) {
    return (
        <Box px={8} py={3}>
            {children}
        </Box>
    )
}
